import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const beforeItems = ['Manual processes and data entry', 'Slow response times to critical events', 'Missed upsell and revenue opportunities', 'High administrative load on staff', 'Fragmented systems and data silos'];
const afterItems = ['Automated, intelligent workflows', 'Instant, context-aware responses', 'Proactive and intelligent upsell', 'Reduced operational drag', 'Unified execution across systems'];
export function BeforeAfter() {
  return <section className="py-32 bg-brand-black relative z-10 border-t border-white/5" data-id="element-113">
      <div className="max-w-6xl mx-auto px-6" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-115">
          <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight leading-[1.0] text-balance" data-id="element-116">
            The Operational Shift.
          </h2>
        </motion.div>

        <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-117">
          {/* Subtle background glow for the 'After' side */}
          <div className="absolute top-0 right-0 bottom-0 w-full md:w-1/2 bg-brand-orange/5 pointer-events-none" data-id="element-118" />
          <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[400px] h-[400px] bg-brand-orange/10 rounded-full blur-[100px] pointer-events-none" data-id="element-119" />

          <div className="grid grid-cols-1 md:grid-cols-2 relative z-10" data-id="element-120">
            {/* Before Panel */}
            <div className="p-8 md:p-16 border-b md:border-b-0 md:border-r border-white/5 relative bg-[#050505]/50" data-id="element-121">
              <h3 className="text-sm font-medium text-gray-500 uppercase tracking-[0.25em] mb-10" data-id="element-122">
                Before Aijentik
              </h3>
              <ul className="space-y-8" data-id="element-123">
                {beforeItems.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-124">
                    <div className="w-6 h-6 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-125">
                      <X className="w-3 h-3 text-gray-500" data-id="element-126" />
                    </div>
                    <span className="text-gray-500 text-lg font-light" data-id="element-127">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>

            {/* After Panel */}
            <div className="p-8 md:p-16 relative" data-id="element-128">
              <h3 className="text-sm font-medium text-brand-orange uppercase tracking-[0.25em] mb-10" data-id="element-129">
                After Aijentik
              </h3>
              <ul className="space-y-8" data-id="element-130">
                {afterItems.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.5,
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-131">
                    <div className="w-6 h-6 rounded-full bg-brand-orange/10 border border-brand-orange/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-132">
                      <Check className="w-3 h-3 text-brand-orange" data-id="element-133" />
                    </div>
                    <span className="text-white text-lg font-medium" data-id="element-134">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}